import { Injectable } from '@angular/core';
import { environment } from '../../../src/environments/env';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, of, tap, switchMap } from 'rxjs';


export interface Country {
  id?: number;
  countryName: string;
}

export interface FeeResponse {
  amount: number;
  feeAmount : any;
  currency: string;
}

export type CountryList = string[];
@Injectable({
  providedIn: 'root'
})
export class FindYourFeeService {

  private token: string | null = null;
  private tokenExpiryTime: number | null = null;
  private tokenDurationMs = 5 * 60 * 1000; // 5 minutes

  constructor(private http: HttpClient) { }

  private apiUrl = environment.BASE_URL + `/ptp/`;
  // public header = { headers: { 'Access-Control-Allow-Origin': '*' } }

  //   public getMctStatuses(): Observable<any[]> {
  //     getCountryFee(): Observable<any> {
  //     return this.http.get<any[]>(this.apiUrl + `api/country-fee/byCountryName/India`, {
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Access-Control-Allow-Origin': '*'
  //       }
  //     });
  //   }


  //   getValidToken(): Observable<{ token: string }> {
  //     const now = Date.now();

  //     // If token exists and is still valid, return it as an observable
  //     if (this.token && this.tokenExpiryTime && now < this.tokenExpiryTime) {
  //       return of({ token: this.token });
  //     }

  //     // Otherwise, fetch a fresh token and update cache tracking parameters
  //     return this.http.get<{ token: string }>(this.apiUrl + 'session/init').pipe(
  //       tap(res => {
  //         this.token = res.token;
  //         this.tokenExpiryTime = Date.now() + this.tokenDurationMs;
  //       })
  //     );
  //   }


  //   getCountries(): Observable<Country[]> {
  //     return this.getValidToken().pipe(
  //       switchMap(session => {
  //         const headers = new HttpHeaders({
  //           'Content-Type': 'application/json',
  //           'Authorization': `Bearer ${session.token}`
  //         });

  //         return this.http.get<Country[]>(this.apiUrl + 'api/country-fee/listOfCountries', { headers });
  //       })
  //     );
  //   }


  //   getFeeInfo(countryName: string, formType: 'NEW_MCT_SUB' | 'TEST_OUT_TRAIN'): Observable<FeeResponse> {
  //     return this.getValidToken().pipe(
  //       switchMap(session => {
  //         const headers = new HttpHeaders({
  //           'Content-Type': 'application/json',
  //           'Authorization': `Bearer ${session.token}`
  //         });

  //         // Set query params
  //         const params = { countryName, formType };

  //         return this.http.get<FeeResponse>(this.apiUrl + 'api/country-fee/byCountryNameAndFormType', { 
  //           headers, 
  //           params 
  //         });
  //       })
  //     );
  //   }
  // }



  getValidToken(): Observable<{ token: string }> {
    const now = Date.now();

    if (this.token && this.tokenExpiryTime && now < this.tokenExpiryTime) {
      return of({ token: this.token });
    }

    // Requests short lived credentials and pipes the token safely back into memory
    return this.http.get<{ accessToken: string }>(this.apiUrl + 'session/init').pipe(
      tap((res:any) => {
        this.token = res.accessToken;
        this.tokenExpiryTime = Date.now() + this.tokenDurationMs;
      })
    );
  }


  // getCountries(): Observable<CountryList> {
  //   return this.getValidToken().pipe(
  //     switchMap(session => {
  //       const headers = new HttpHeaders({
  //         'Content-Type': 'application/json',
  //         'Authorization': `Bearer ${session.token}`
  //       });

  //       return this.http.get<CountryList>(this.apiUrl + 'api/country-fee/listOfCountries', { headers });
  //     })
  //   );
  // }

  getCountries(): Observable<CountryList> {
  return this.getValidToken().pipe(
    switchMap(() => { // Drop the unmapped 'session' parameter
      const headers = new HttpHeaders({
        //'Content-Type': 'application/json',
        //'Access-Control-Allow-Origin': '*',
        'Authorization': `Bearer ${this.token}` // Directly access your verified class property
      });
 
      return this.http.get<CountryList>(this.apiUrl + 'api/country-fee/listOfCountries', { headers });
    })
  );
}


  getFeeInfo(countryName: string, formType: 'NEW_MCT_SUB' | 'TEST_OUT_TRAIN' | 'ILT_TRAIN_SUB'): Observable<FeeResponse> {
    return this.getValidToken().pipe(
      switchMap(session => {
        const headers = new HttpHeaders({
          //'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Authorization': `Bearer ${session.token}`
        });

        const params = { countryName, formType };

        return this.http.get<FeeResponse>(this.apiUrl + 'api/country-fee/byCountryNameAndFormType', {
          headers,
          params
        });
      })
    );
  }
}

